import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex min-h-screen bg-gray-100 text-gray-800" }
const _hoisted_2 = { class: "sidebar-header" }
const _hoisted_3 = { class: "flex-1 p-4 space-y-1" }
const _hoisted_4 = { class: "account-content" }

import { ref, onMounted, onBeforeUnmount } from 'vue';
import ConfirmPopup from 'primevue/confirmpopup';
import Toast from 'primevue/toast';
import Button from 'primevue/button';


export default {
  __name: 'AdminLayout',
  setup(__props) {

const menu = [
    { label: 'Kategorie', to: '/administration/categories', icon: 'pi pi-tag' },
    { label: 'Użytkownicy', to: '/administration/users', icon: 'pi pi-users' },
    { label: 'Płatności', to: '/administration/payments', icon: 'pi pi-credit-card' },
    { label: 'Opinie', to: '/administration/opinions', icon: 'pi pi-star' },
    { label: 'Szablony email', to: '/administration/mail-contents', icon: 'pi pi-envelope' },
    { label: 'Ustawienia', to: '/administration/settings', icon: 'pi pi-cog' }
];

const isSidebarOpen = ref(false);
const isMobile = ref(false);

const checkMobile = () => {
    isMobile.value = window.innerWidth <= 768;
    if (!isMobile.value) {
        isSidebarOpen.value = false;
    }
};

const toggleSidebar = () => {
    if (isMobile.value) {
        isSidebarOpen.value = !isSidebarOpen.value;
    }
};

const closeSidebar = () => {
    isSidebarOpen.value = false;
};

onMounted(() => {
    checkMobile();
    window.addEventListener('resize', checkMobile);
});

onBeforeUnmount(() => {
    window.removeEventListener('resize', checkMobile);
});

return (_ctx, _cache) => {
  const _component_TopNav = _resolveComponent("TopNav")
  const _component_router_link = _resolveComponent("router-link")
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TopNav, { onToggleSidebar: toggleSidebar }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("aside", {
        class: _normalizeClass(["sidebar", { 'sidebar-open': isSidebarOpen.value }])
      }, [
        _createElementVNode("div", _hoisted_2, [
          (isMobile.value)
            ? (_openBlock(), _createBlock(_unref(Button), {
                key: 0,
                icon: "pi pi-times",
                text: "",
                onClick: closeSidebar,
                class: "close-sidebar-btn"
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("nav", _hoisted_3, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menu, (item) => {
            return _createVNode(_component_router_link, {
              key: item.to,
              to: item.to,
              onClick: closeSidebar
            }, {
              default: _withCtx(() => [
                _createElementVNode("i", {
                  class: _normalizeClass(["menu-icon", item.icon])
                }, null, 2),
                _createElementVNode("span", null, _toDisplayString(item.label), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          }), 64))
        ])
      ], 2),
      (isMobile.value && isSidebarOpen.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "sidebar-overlay",
            onClick: closeSidebar
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_view)
      ])
    ]),
    _createVNode(_unref(Toast)),
    _createVNode(_unref(ConfirmPopup))
  ], 64))
}
}

}